export default {
  meta: {
    title: '机会点管理',
    url: '/fishtogether/chancepointmanage', // 埋点用，记录所属模块
    // eventId: '93fc1755-8e57-4ce9-978a-3fe48cc43aca'
  },
};
